// useOrientation.js
// Reports "landscape" or "landscape" based on the viewport dimensions.
// OBS Browser Sources render at the canvas size set on the source — so
// portrait scenes (1080×1920) come through as window.innerHeight > innerWidth
// even though the user agent is the same.
import { useState, useEffect } from "react";

export default function useOrientation() {
  const [orientation, setOrientation] = useState(
    typeof window !== "undefined" && window.innerWidth < window.innerHeight
      ? "portrait"
      : "landscape"
  );

  useEffect(() => {
    const check = () => {
      setOrientation(window.innerWidth < window.innerHeight ? "portrait" : "landscape");
    };
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  return orientation;
}
